import {
  GET_MAP_PLATES_REQUEST,
  GET_MAP_PLATES_ERROR,
  GET_MAP_PLATES_SUCCESS,
  DELETE_MAP_PLATE_REQUEST,
  DELETE_MAP_PLATE_SUCCESS,
  DELETE_MAP_PLATE_ERROR,
  CREATE_MAP_PLATE_REQUEST,
  CREATE_MAP_PLATE_SUCCESS,
  CREATE_MAP_PLATE_ERROR,
  GET_PLATE_SUGGESTIONS_REQUEST,
  GET_PLATE_SUGGESTIONS_SUCCESS,
  GET_PLATE_SUGGESTIONS_ERROR,
  GET_MAP_PLATES_PROGRESS,
} from 'redux/actions';

export const getMapPlatesRequest = (page = 1, filters = {}) => ({
  type: GET_MAP_PLATES_REQUEST,
  payload: {
    page,
    filters,
  },
});

export const getMapPlatesSuccess = (
  plates,
  meta,
  links,
  success,
  progress
) => ({
  type: GET_MAP_PLATES_SUCCESS,
  payload: {
    plates,
    meta,
    links,
    success,
    progress,
  },
});

export const getMapPlatesError = (message) => ({
  type: GET_MAP_PLATES_ERROR,
  payload: { message },
});

export const getPlateSuggestionsRequest = () => ({
  type: GET_PLATE_SUGGESTIONS_REQUEST,
});

export const getPlateSuggestionsSuccess = (plateSuggestions) => ({
  type: GET_PLATE_SUGGESTIONS_SUCCESS,
  payload: { plateSuggestions },
});

export const getPlateSuggestionsError = (message) => ({
  type: GET_PLATE_SUGGESTIONS_ERROR,
  payload: { message },
});

export const createMapPlateRequest = (data) => ({
  type: CREATE_MAP_PLATE_REQUEST,
  payload: data,
});

export const createMapPlateSuccess = (plate, success, message = null) => ({
  type: CREATE_MAP_PLATE_SUCCESS,
  payload: {
    plate,
    success,
    message,
  },
});

export const createMapPlateError = (message) => ({
  type: CREATE_MAP_PLATE_ERROR,
  payload: { message },
});

export const deleteMapPlateRequest = (id) => ({
  type: DELETE_MAP_PLATE_REQUEST,
  payload: { id },
});

export const deleteMapPlateSuccess = (id, success, message) => ({
  type: DELETE_MAP_PLATE_SUCCESS,
  payload: {
    id,
    success,
    message,
  },
});

export const deleteMapPlateError = (message) => ({
  type: DELETE_MAP_PLATE_ERROR,
  payload: { message },
});

export const getMapPlatesProgress = (progress) => ({
  type: GET_MAP_PLATES_PROGRESS,
  payload: { progress },
});
